export default __webpack_public_path__ + "ec6f2088bc74d6302f2429af457ce7f3.png";